import React from 'react';
import { Link } from 'react-router-dom';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

import { CgPlayPauseO, CgPlayButtonO } from 'react-icons/cg';

import { TableSortLabel } from 'components/Table';
import { formatDate } from '../../../../utils/time';
import { RenderIconButton } from '../../Channel/shared/components/GenericComponents';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    margin: '0 0 20px 20px',
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    padding: 16,
  },
});

class TemplateList extends React.Component {
  render() {
    const { classes, items, count, pageSize, page, onChangePage, onChangeRowsPerPage } =
      this.props;

    return (
      <div className={classes.root}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            component={Link}
            to="/dashboard/agency/new"
          >
            create new referral code
          </Button>
        </div>

        <Paper elevation={0}>
          <Typography className={classes.title} variant="subtitle1">
            Referral Codes
          </Typography>

          <Table>
            <TableHead>
              <TableRow>
                <TableSortLabel label="Full Name" field="fullName" container={this} />

                <TableSortLabel label="Email" field="email" container={this} />
                <TableSortLabel label="Phone" field="phone" container={this} />

                <TableSortLabel label="Referral Code" field="code" container={this} />

                <TableSortLabel label="Created at" field="createdAt" container={this} />

                <TableSortLabel label="Expire at" field="expireAt" container={this} />

                <TableSortLabel label="Limit" field="limit" container={this} />

                <TableSortLabel label="Used" field="used" container={this} />

                <TableSortLabel label="Active" field="active" container={this} />
              </TableRow>
            </TableHead>

            <TableBody>
              {items.map(row => (
                <TableRow key={row._id} hover>
                  <TableCell>{row.fullName}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.phone}</TableCell>
                  <TableCell>{row.code}</TableCell>
                  <TableCell>{formatDate(row.createdAt)}</TableCell>
                  <TableCell>
                    {row.expireAt ? formatDate(row.expireAt) : 'unlimited'}
                  </TableCell>
                  <TableCell>{row.limit ? row.limit : 'unlimited'}</TableCell>
                  <TableCell>{row.used}</TableCell>

                  <TableCell>
                    <RenderIconButton
                      clickEvent={() => {
                        this.props.activePauseCode(row._id);
                      }}
                      color={row.active ? 'primary' : 'secondary'}
                      title={row.active ? 'Pause code' : 'Start code'}
                      placement={'top'}
                      icon={
                        row.active ? (
                          <CgPlayPauseO fontSize="25px" />
                        ) : (
                          <CgPlayButtonO fontSize="25px" />
                        )
                      }
                      theme="host"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={count}
            rowsPerPage={pageSize}
            page={page}
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangeRowsPerPage}
          />
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(TemplateList);
